function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState } from 'react';
import Axios from 'axios';
let restDataCache = {};
export default ((dataPath, cacheKey, initialState) => {
  const _useState = useState(initialState),
        _useState2 = _slicedToArray(_useState, 2),
        restData = _useState2[0],
        setRestData = _useState2[1];

  useEffect(() => {
    if (restDataCache[cacheKey]) {
      return setRestData(restDataCache[cacheKey]);
    }

    Axios.get(dataPath).then(response => {
      restDataCache[cacheKey] = response.data;
      setRestData(response.data);
    });
  }, []);
  return restData;
});